// Fragment "tenant entitlements" — super_admin/tenants/EntitlementsEditorModal.jsx and the
// Tenants row action that opens it. Merged by ./index.js. It replaces the retired
// per-tenant module editor (its `tl.mod.*` / `tl.addons*` keys are gone with it).
export default {
  fr: {
    "tent.open": "Fonctionnalités et limites",
    "tent.title": "Fonctionnalités — {name}",
    "tent.note": "Modifie uniquement ce cabinet. Il conserve ces réglages jusqu'à son prochain changement de forfait.",
    "tent.limits": "Limites",
    "tent.used": "Utilisé : {n}",
    "tent.paidAddon": "Add-on payant",
    "tent.save": "Enregistrer",
    "tent.saved": "Fonctionnalités de {name} mises à jour.",
    "tent.loadError": "Impossible de charger les fonctionnalités de ce cabinet.",
    "tent.retry": "Réessayer",
    "tent.limitInvalid": "Nombre entier positif, ou vide pour illimité.",
    "tent.paidLineDepends": "Ce cabinet paie des add-ons qui en dépendent : {lines}. Retirez d’abord ces lignes de sa facture.",
  },
  en: {
    "tent.open": "Features & limits",
    "tent.title": "Features — {name}",
    "tent.note": "Changes this practice only. It keeps these settings until its next plan change.",
    "tent.limits": "Limits",
    "tent.used": "Used: {n}",
    "tent.paidAddon": "Paid add-on",
    "tent.save": "Save",
    "tent.saved": "Features of {name} updated.",
    "tent.loadError": "This practice's features could not be loaded.",
    "tent.retry": "Try again",
    "tent.limitInvalid": "A whole number of zero or more, or blank for unlimited.",
    "tent.paidLineDepends": "This practice pays for add-ons that depend on it: {lines}. Remove those lines from its bill first.",
  },
  es: {
    "tent.open": "Funciones y límites",
    "tent.title": "Funciones — {name}",
    "tent.note": "Cambia solo esta consulta. Conserva estos ajustes hasta su próximo cambio de plan.",
    "tent.limits": "Límites",
    "tent.used": "Usado: {n}",
    "tent.paidAddon": "Add-on de pago",
    "tent.save": "Guardar",
    "tent.saved": "Funciones de {name} actualizadas.",
    "tent.loadError": "No se pudieron cargar las funciones de esta consulta.",
    "tent.retry": "Volver a intentar",
    "tent.limitInvalid": "Un número entero de cero o más, o vacío para ilimitado.",
    "tent.paidLineDepends": "Esta consulta paga add-ons que dependen de ello: {lines}. Quita primero esas líneas de su factura.",
  },
};
